import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getPublicStats } from "../lib/publicStats";
import { Fire } from "@phosphor-icons/react";
import { useI18n } from "../lib/i18n";

/**
 * Header scarcity chip — shows remaining launch-offer slots from /public/stats.
 * Hidden on /passez-partenaire (redundant) and when all 100 slots are taken.
 * Pulse animation to grab attention without being annoying. i18n-aware.
 */
const LIMIT = 100;

export default function ScarcityBadge() {
  const { t } = useI18n();
  const [remaining, setRemaining] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    getPublicStats().then((r) => {
      const taken = r.data?.premium_businesses ?? 0;
      setRemaining(Math.max(0, LIMIT - taken));
    }).catch(() => {});
  }, []);

  if (remaining === null || remaining === 0) return null;
  if (pathname.startsWith("/passez-partenaire")) return null;

  return (
    <Link
      to="/passez-partenaire"
      title={t.scarcity.tooltip.replace("{n}", remaining)}
      className="hidden lg:inline-flex items-center gap-1.5 bg-secondary/10 border border-secondary/40 text-secondary hover:bg-secondary hover:text-secondary-foreground text-xs font-bold px-2.5 py-1 rounded-full transition-colors group"
      data-testid="header-scarcity-chip"
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-secondary" />
      </span>
      <Fire size={10} weight="fill" />
      <span className="tabular-nums">{t.scarcity.remaining.replace("{n}", remaining)}</span>
    </Link>
  );
}
